//TODO: TESTS
import React from "react";

interface AcademyGridSkeletonProps {
  visible: boolean;
  count?: number;
}

const GRID_PLACEHOLDERS_COUNT = 8;

const AcademyGridSkeleton: React.FC<AcademyGridSkeletonProps> = ({
  visible,
  count = GRID_PLACEHOLDERS_COUNT,
}) => {
  if (!visible) return null;

  const gridItemsRange = Array.from({ length: count }, (_, i) => i);

  return (
    <div
      cy-test-id="academy-grid-skeleton"
      className="w-full flex flex-wrap justify-center md:justify-between gap-4 bg-[#252A2D]"
    >
      {gridItemsRange.map((index) => (
        <div
          key={index}
          className="w-full sm:w-[calc(50%-10px)] md:w-[300px] lg:w-[320px] xl:w-[370px] flex-grow-0 flex-shrink-0 max-w-[400px]"
        >
          <div className="rounded-[5px] max-w-[400px] overflow-hidden">
            {/* Image placeholder */}
            <div className="w-full h-[253px] bg-a-dark-gray animate-pulse rounded-t-[5px]"></div>

            <div className="px-5 pb-5 pt-3 max-h-[162px] flex flex-col gap-y-4">
              {/* Software icons placeholder */}
              <div className="flex items-center h-[24px] max-w-[400px]">
                <div className="w-6 h-6 rounded-full bg-a-dark-gray animate-pulse"></div>
                <div className="w-6 h-6 ml-2 rounded-full bg-a-dark-gray animate-pulse"></div>
              </div>

              {/* Title placeholder */}
              <div className="h-[48px] w-full">
                <div className="h-[18px] w-[90%] mb-2 bg-a-dark-gray animate-pulse rounded-[3px]"></div>
                <div className="h-[18px] w-[75%] bg-a-dark-gray animate-pulse rounded-[3px]"></div>
              </div>

              {/* Asset type placeholder */}
              <div className="flex gap-6">
                <div className="h-[12px] w-[100px] bg-a-dark-gray animate-pulse rounded-[3px]"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AcademyGridSkeleton;
